import controller from './procedure-list.controller';
import templateBase from './views/procedure-list.view-t1.html';
import templateAD from './views/procedure-list.adaptative.html';


let ProcedureListComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    categorySlug: "<",
    categoryId : '<',
    productsList : '<',
    typeview : '<'
  }
};


function changeTemplate() {
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateBase;
  }
}

export default ProcedureListComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/procedure-list/procedure-list.component.js
 **/